import {
  __,
  getProp,
  validateEmail,
  validatePhone,
  containsCyrillic,
} from '../../utilities';

const validate = (values, props) => {
  const text = __('Pole je povinné');

  const errors = {};
  const ticketsArrayErrors = [];
  getProp(values, ['passengers'], []).forEach((passenger, passengerIdx) => {
    const ticketErrors = {};
    if (!passenger || !passenger.name) {
      ticketErrors.name = text;
    } else if (containsCyrillic(passenger.name)) {
      ticketErrors.name = __('Prosím nepoužívajte azbuku');
    }
    if (!passenger || !passenger.surname) {
      ticketErrors.surname = text;
    } else if (containsCyrillic(passenger.surname)) {
      ticketErrors.surname = __('Prosím nepoužívajte azbuku');
    }

    // kontrola ci hlavny pasazier vyplnil mail a tel. cislo + validacia formatu
    if (passengerIdx === 0) {
      if (!passenger || !passenger.email) {
        ticketErrors.email = text;
      }
      if (!validateEmail(passenger.email)) {
        ticketErrors.email = __('Nesprávny formát emailu!');
      }
      if (!validatePhone(passenger.phone)) {
        ticketErrors.phone = __('Nesprávny formát mobilného čísla!');
      }
      if (!passenger || !passenger.phone) {
        ticketErrors.phone = text;
      }
      if (props.register) {
        if (!passenger || !passenger.pass) {
          ticketErrors.pass = text;
        }
      }
    }

    // kontrola vybratia tarif vo vsetkych listkoch
    props.selectedTicketPrices[passengerIdx].forEach(
      (ticketPrice, ticketIdx) => {
        if (ticketPrice === null) {
          if (!('tickets' in ticketErrors)) {
            ticketErrors.tickets = [];
          }
          ticketErrors.tickets[ticketIdx] = __('Vyberte tarifu');
        }
      },
    );

    if (Object.keys(ticketErrors).length > 0) {
      ticketsArrayErrors[passengerIdx] = ticketErrors;
    }
  });
  if (ticketsArrayErrors.length) {
    errors.passengers = ticketsArrayErrors;
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/containers/Passengers/validate.js